import { render, staticRenderFns } from "./TempRankingEditor.vue?vue&type=template&id=85872f8e"
import script from "./TempRankingEditor.vue?vue&type=script&lang=js"
export * from "./TempRankingEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports